/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../graphql.generated'

const defaultOptions = {} as const
export type FeatureFlagFieldsFragment = {
  __typename?: 'FeatureFlag'
  key: string
  enabled: boolean
  toggleable: boolean
  overridden: boolean
}

export type FeatureFlagsQueryVariables = Types.Exact<{ [key: string]: never }>

export type FeatureFlagsQuery = {
  __typename?: 'Query'
  featureFlags: Array<{
    __typename?: 'FeatureFlag'
    key: string
    enabled: boolean
    toggleable: boolean
    overridden: boolean
  }>
}

export type SetFeatureFlagOverrideMutationVariables = Types.Exact<{
  key: Types.Scalars['String']['input']
  enabled: Types.Scalars['Boolean']['input']
}>

export type SetFeatureFlagOverrideMutation = {
  __typename?: 'Mutation'
  setFeatureFlagOverride: Array<{
    __typename?: 'FeatureFlag'
    key: string
    enabled: boolean
    toggleable: boolean
    overridden: boolean
  }>
}

export const FeatureFlagFieldsFragmentDoc = gql`
  fragment FeatureFlagFields on FeatureFlag {
    key
    enabled
    toggleable
    overridden
  }
`
export const FeatureFlagsDocument = gql`
  query featureFlags {
    featureFlags {
      ...FeatureFlagFields
    }
  }
  ${FeatureFlagFieldsFragmentDoc}
`

/**
 * __useFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureFlagsQuery(
  baseOptions?: Apollo.QueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options)
}
export function useFeatureFlagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options)
}
export type FeatureFlagsQueryHookResult = ReturnType<typeof useFeatureFlagsQuery>
export type FeatureFlagsLazyQueryHookResult = ReturnType<typeof useFeatureFlagsLazyQuery>
export type FeatureFlagsQueryResult = Apollo.QueryResult<FeatureFlagsQuery, FeatureFlagsQueryVariables>
export const SetFeatureFlagOverrideDocument = gql`
  mutation setFeatureFlagOverride($key: String!, $enabled: Boolean!) {
    setFeatureFlagOverride(key: $key, enabled: $enabled) {
      ...FeatureFlagFields
    }
  }
  ${FeatureFlagFieldsFragmentDoc}
`
export type SetFeatureFlagOverrideMutationFn = Apollo.MutationFunction<
  SetFeatureFlagOverrideMutation,
  SetFeatureFlagOverrideMutationVariables
>

/**
 * __useSetFeatureFlagOverrideMutation__
 *
 * To run a mutation, you first call `useSetFeatureFlagOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFeatureFlagOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFeatureFlagOverrideMutation, { data, loading, error }] = useSetFeatureFlagOverrideMutation({
 *   variables: {
 *      key: // value for 'key'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetFeatureFlagOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<SetFeatureFlagOverrideMutation, SetFeatureFlagOverrideMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SetFeatureFlagOverrideMutation, SetFeatureFlagOverrideMutationVariables>(
    SetFeatureFlagOverrideDocument,
    options
  )
}
export type SetFeatureFlagOverrideMutationHookResult = ReturnType<typeof useSetFeatureFlagOverrideMutation>
export type SetFeatureFlagOverrideMutationResult = Apollo.MutationResult<SetFeatureFlagOverrideMutation>
export type SetFeatureFlagOverrideMutationOptions = Apollo.BaseMutationOptions<
  SetFeatureFlagOverrideMutation,
  SetFeatureFlagOverrideMutationVariables
>
